<div>

  <app-featured-events></app-featured-events>


  <div class="pb-4">
    <tabset>
      <!-- <tab heading="Inplay" (selectTab)="onSelect({id:'in_play' , name: 'in_play'})">
        <app-d-sport-list *ngIf="tabId == 'in_play'" [list]="data" [eventId]="'in_play'" [oddsData]="oddsLisDis"></app-d-sport-list>
      </tab> -->

      <div class="filter-ct" *ngIf="!events.races.includes(tabId) && !events.casino.includes(tabId)">
        <label>View by:</label>
        <select class="form-control-sm" [(ngModel)]="viewBy">
          <option value="c">Competitions</option>
          <option value="t">Time</option>
        </select>
      </div>

      <!-- <tab [heading]="mn.name.includes('In') ? mn.name : eventsName[mn.id]" *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="onSelect(mn)"> -->
      <tab [heading]="mn.name" *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="onSelect(mn)">

        <!-- tab-content -->
        <app-d-sport-list *ngIf="tabId == mn.id && (!events.casino.includes(mn.id))" [viewBy]="viewBy" [list]="mn.name.includes('In') ? inPlayData : data" [eventId]="mn.id" [oddsData]="oddsLisDis"></app-d-sport-list>
        <app-d-casino *ngIf="tabId == mn.id && events.casino.includes(mn.id)" [gameId]="mn.id"></app-d-casino>
        <!-- /tab-content -->

        <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>

      </tab>
    </tabset>

  </div>

  <!-- Home Products content -->
  <div class="home-products-container" *ngIf="events.sports.includes(tabId) || tabId == 'in_play'">
    <div class="row row5">
      
      
      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasinoDetail(99995, 883)">
          <img src="https://speedcdn.io/assets/casinogames-new-video/aviator-animate.gif" class="img-fluid">
          <div class="casino-name">Aviator</div>
        </div>
      </div>
      <div href="javascript:void(0)" (click)="_common.openLogin()" [routerLink]="env.isMobile ? ['/m/casino-detail', 99999, item.id] : ['/casino-detail', 99999, item?.id]" *ngFor="let item of casinoData;trackBy:trackByIndex;" class="col-casino">
        <div class="casinoicons">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-v1/{{item?.id}}.webp" class="img-fluid">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/{{item?.id}}.gif" class="img-fluid">
          <div class="casino-name">{{item?.name}}</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:royal-gaming')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/rg.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/rg.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Royal Gaming</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:evolution-gaming')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/evolutions.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/evolutions.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Evolution Gaming</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:onetouch')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/onetouch.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/onetouch.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">One Touch</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:ae-sexy')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/aesexy.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/aesexy.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">AE Sexy</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:betgamestv')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/betgames.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/betgames.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Bet Games</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:bombay-live')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/bombaylive.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/bombaylive.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Bombay Live</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:ezugi')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/ezugi.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/ezugi.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Ezugi</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:gamzix')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/gamezix.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/gamezix.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Gamezix</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:jili-gaming')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/jili.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/jili.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Jili</div>
        </div>
      </div>

      <div class="col-casino">
        <div class="d-inline-block casinoicons" (click)="redirectCasino('99995:kingmaker')">
          <img *ngIf="!domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/diamond-client-v8/casino/kingmaker.jpg" class="img-fluid" style="height: 95px;">
          <img *ngIf="domainList.includes(env.host.domain)" src="https://speedcdn.io/assets/casinogames-new-video/kingmaker.gif" class="img-fluid" style="height: 95px;">
          <div class="casino-name">Kingmaker</div>
        </div>
      </div>
      
      <!-- <div class="col-md-12">
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/superover.jpg" class="img-fluid">
            <div class="casino-name">Super Over</div>
            <div class="new-launch-casino"><img src="assets/img/offer-patch.png"></div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/race20.png" class="img-fluid">
            <div class="casino-name">Race 20-20</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/queen.jpg" class="img-fluid">
            <div class="casino-name">Casino Queen</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/cricketv3.jpg" class="img-fluid">
            <div class="casino-name">5Five Cricket</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/andar-bahar2.jpg" class="img-fluid">
            <div class="casino-name">Andar Bahar 2</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/dt202.jpg" class="img-fluid">
            <div class="casino-name">20-20 Dragon Tiger 2</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/baccarat2.jpg" class="img-fluid">
            <div class="casino-name">Baccarat 2</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/baccarat.png" class="img-fluid">
            <div class="casino-name">Baccarat</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/lucky7eu.jpg" class="img-fluid">
            <div class="casino-name">Lucky 7 - B</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/teencasino.jpg" class="img-fluid">
            <div class="casino-name">Teenpatti 2.0</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/cc-20.jpg" class="img-fluid">
            <div class="casino-name">20-20 Cricket Match</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/cmeter.jpg" class="img-fluid">
            <div class="casino-name">Casino Meter</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/war.jpg" class="img-fluid">
            <div class="casino-name">Casino War</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/dtl.jpg" class="img-fluid">
            <div class="casino-name">20-20 DTL</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/teenpatti.jpg" class="img-fluid">
            <div class="casino-name">Test Teenpatti</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/teenpatti.jpg" class="img-fluid">
            <div class="casino-name">Open Teenpatti</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/teenpatti.jpg" class="img-fluid">
            <div class="casino-name">1 Day Teenpatti</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/teenpatti.jpg" class="img-fluid">
            <div class="casino-name">20-20 Teenpatti</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/poker.jpg" class="img-fluid">
            <div class="casino-name">6 Player Poker</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/poker.jpg" class="img-fluid">
            <div class="casino-name">1 Day Poker</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/poker.jpg" class="img-fluid">
            <div class="casino-name">20-20 Poker</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/andar-bahar.jpg" class="img-fluid">
            <div class="casino-name">Andar Bahar</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/worli.jpg" class="img-fluid">
            <div class="casino-name">Worli Matka</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/worli.jpg" class="img-fluid">
            <div class="casino-name">Instant Worli</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/3cardsJ.jpg" class="img-fluid">
            <div class="casino-name">3 Cards Judgement</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/32cardsA.jpg" class="img-fluid">
            <div class="casino-name">32 Cards A</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/32cardsB.jpg" class="img-fluid">
            <div class="casino-name">32 Cards B</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/aaa.jpg" class="img-fluid">
            <div class="casino-name">Amar Akbar Anthony</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/bollywood-casino.jpg" class="img-fluid">
            <div class="casino-name">Bollywood Casino</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/dt.jpg" class="img-fluid">
            <div class="casino-name">20-20 Dragon Tiger</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/dt.jpg" class="img-fluid">
            <div class="casino-name">1 Day Dragon Tiger</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/lottery.jpg" class="img-fluid">
            <div class="casino-name">Lottery</div>
          </div>
        </a>
        <a href="javascript:void(0)" class="">
          <div class="d-inline-block casinoicons">
            <img src="assets/img/lucky7.jpg" class="img-fluid">
            <div class="casino-name">Lucky 7 - A</div>
          </div>
        </a>
      </div> -->
    </div>
  </div>
  <!--/ Home Products content End -->
</div>